import type { ValueOf } from './util/typeUtils';

export const OFFER_ACCEPTANCE_STATUSES = {
    FAILURE: 'FAILURE',
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    TIMEOUT: 'TIMEOUT',
} as const;
export type OFFER_ACCEPTANCE_STATUS = keyof typeof OFFER_ACCEPTANCE_STATUSES;

export const OFFER_DOCUMENT_UPLOAD_STATUSES = {
    FAILED: 'FAILED',
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
} as const;
export type OFFER_DOCUMENT_UPLOAD_STATUS = ValueOf<typeof OFFER_DOCUMENT_UPLOAD_STATUSES>;
